import React, { useContext, useState } from "react";
import CardComponent from "../../components/CardComponent";
import { MqttContext } from "../../contexts/MqttContext";
import { LocalesContext } from "../../contexts/LocalesContext";
import { gridSizesClassName } from "../../utils/gridSizes";

export default function RealtimeComponent(props) {
  const {
    machineParams,
    machineName,
    machineRtStatus,
    actions: { getMachineParams, sendMessageWithAnswer },
  } = useContext(MqttContext);
  const [ctaEnabled, setCtaEnabled] = useState(true);
  const { t } = useContext(LocalesContext);

  let status = machineRtStatus;
  let classNameStatus = "";
  let labelDataStatus = "";
  let labelAction = "";
  let labelClass = "";
  let functionAction = null;

  if (status == "connected") {
    classNameStatus = "is-connected";
    labelDataStatus = t("application.connestion_statuses.connected");
    labelClass="c-table__status--connected";
    labelAction = t("application.cta.update_status");
    functionAction = () => {
      setCtaEnabled(false);
      sendMessageWithAnswer(
        "RD_DATA",
        { dataGroup: "work" },
        "MACHINE_DATA",
        () => setCtaEnabled(true)
      );
    };
  } else if (status == "warning") {
    classNameStatus = "is-warning";
    labelDataStatus = t("application.connestion_statuses.warning");
    labelAction = t("application.cta.view_alarms");
    labelClass="c-table__status--warning";
    functionAction = props.showAlarms;
  } else if (status == "alarm") {
    classNameStatus = "is-error";
    labelDataStatus = t("application.connestion_statuses.error");
    labelAction = t("application.cta.view_alarms");
    labelClass="c-table__status--alarm";
    functionAction = props.showAlarms;
  } else if (status == "disconnected") {
    classNameStatus = "is-disconnected";
    labelDataStatus = t("application.connestion_statuses.disconnected");
    labelClass="c-table__status--disconnected";
    labelAction = t("application.cta.update_status");
    functionAction = () => {
      setCtaEnabled(false);
      sendMessageWithAnswer(
        "RD_DATA",
        { dataGroup: "work" },
        "MACHINE_DATA",
        () => {
          getMachineParams(() => setCtaEnabled(true), false);
        }
      );
    };
  } else if (status == "working") {
    classNameStatus = "is-working";
    labelDataStatus = t("application.connestion_statuses.working");
    labelAction = t("application.cta.view_alarms");
    labelClass="c-table__status--working";
    functionAction = props.showAlarms;
  }

  return (
    <>
      <div className={`r-realtime__status ${classNameStatus}`}></div>
      <div className="r-realtime__container row row--actions">
        <div className="r-realtime__data">
          <div className="r-realtime__data-name">{machineName}</div>
          <div className={"c-table__status " + labelClass}>{labelDataStatus}</div>
        </div>
        {labelAction && functionAction && (
          <button
            className="c-button"
            onClick={functionAction}
            disabled={!ctaEnabled}
          >
            {labelAction}
          </button>
        )}
      </div>
    </>
  );
}
